export interface LocalizedNames {
  name_ru: string;
  name_en: string;
  name_kk: string;
  name?: string;
}

export interface Country extends LocalizedNames {
  code: string;
  iso_code: string;
}

export interface City extends LocalizedNames {
  code: string;
}

export interface Airport extends LocalizedNames {
  code: string;
}

interface Airline extends LocalizedNames {
  code: string;
}

export interface Location {
  country: Country;
  city: City;
  airport: Airport;
}

export interface Price {
  currency: string;
  amount: string;
}

export interface Result {
  origin: Location;
  destination: Location;
  price: Price;
  dep_date: string; // e.g., "2024-12-22"
  search_query: string; // e.g., "NQZ-AYT202412231000E"
  created_at: string;
  image: string;
  display_airlines: Airline[];
  segments_quantity: number;
  is_direct: boolean;
  flight_time: number; // seconds
  dep_at: string; // ISO timestamp
  arr_at: string; // ISO timestamp
}

export interface HotOffersResponse {
  total: number;
  results: Result[];
}
